/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * De-risking action type
 */
export enum DeRiskingActionType {

    None = 'none',

    Monitor = 'monitor',

    Reduce50Pct = 'reduce50_pct',

    CloseAll = 'close_all',

    KillSwitch = 'kill_switch'
}
